import { useQuery } from '@tanstack/react-query';
export const useSolutionQuery = (tab) => {
    return useQuery(['tab', tab?.explore_item_api], async () => {
        try {
            const response = await fetch(`/${tab.explore_item_api}`);
            return await response.json();
        }
        catch (error) {
            return error;
        }
    }, {
        enabled: tab !== undefined,
    });
};
